// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__3ArK2","button":"NavBar_button__1MuXA"};